import { TranslocoService } from '@jsverse/transloco';
import { Observable, catchError, forkJoin, of } from 'rxjs';

export const APP_LANG_SCOPES = ['shared', 'menu', 'dashboard', 'admin'] as const;

export function preloadAppLang(transloco: TranslocoService, lang: string): Observable<unknown> {
    return forkJoin([transloco.load(lang), ...APP_LANG_SCOPES.map((scope) => transloco.load(`${scope}/${lang}`))]).pipe(
        catchError(() => of(null)),
    );
}
